/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ToolsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    onClick={props.onClick}
  >
    <g>
      <path d="M13.5,9 C13.5,5.962 11.037,3.5 8,3.5 C4.963,3.5 2.5,5.962 2.5,9 C2.5,11.517 4.193,13.634 6.5,14.287 L6.5,15.5 L5.5,16.499 L6.5,17.5 L6.5,18.5 L5.5,19.5 L6.5,20.5 L6.5,22 L8,23.5 L9.5,22 L9.5,14.287 C11.807,13.634 13.5,11.517 13.5,9 Z" />
      <circle cx="8" cy="7" r="1.5" />
      <path d="M9.5,15.013 C11.172,15.978 13.242,15.986 14.925,15.046 L16,16 L16,17.5 L17.5,17.5 L18,18.024 L18,19.5 L19.317,19.5 L20.379,20.5 L22.5,20.5 L22.5,18.379 L17.046,12.925 C18.216,10.832 17.915,8.137 16.136,6.358 C14.882,5.104 13.174,4.582 11.541,4.792" />
      <path d="M8,7 L8,2.5 C8,1.396 8.896,0.5 10,0.5 C11.104,0.5 12,1.396 12,2.5 L12,4.752" />
    </g>
  </svg>
);

export default ToolsIcon;
